import { cn } from '../../../lib/utils'
import { ButtonHTMLAttributes, ReactNode } from 'react'

interface GlassButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  size?: 'sm' | 'md' | 'lg' | 'full'
  loading?: boolean
  icon?: ReactNode
}

export function GlassButton({
  variant = 'primary',
  size = 'md',
  loading = false,
  icon,
  children,
  className,
  disabled,
  ...props
}: GlassButtonProps) {
  const variants = {
    primary:   'bg-gradient-to-r from-primary to-accent text-white hover:from-primary-light hover:to-accent-bright shadow-glow-sky',
    secondary: 'bg-white/[0.08] border border-white/20 text-white hover:bg-white/[0.14] hover:border-white/30',
    ghost:     'text-white/70 hover:text-white hover:bg-white/[0.06]',
    danger:    'bg-red-500/20 border border-red-500/30 text-red-400 hover:bg-red-500/30',
  }
  const sizes = {
    sm:   'px-3 py-1.5 text-xs rounded-lg gap-1.5',
    md:   'px-5 py-2.5 text-sm rounded-xl gap-2',
    lg:   'px-8 py-3.5 text-base rounded-xl gap-2',
    full: 'w-full px-5 py-3 text-sm rounded-xl gap-2',
  }
  return (
    <button
      className={cn(
        'font-medium transition-all duration-200 flex items-center justify-center',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      ) : icon}
      {children}
    </button>
  )
}
